import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * A dead ball with no player involved: the ball grounded and the play is over
 * where it lies. Flag football only, and only after a fumbled snap - it is the
 * terminal that keeps that flow completable when the Fumble option is gated
 * off by general.fumbleFlowEnabled. Carries the dead ball spot and nothing
 * else; who muffed the snap is already on the FumbledSnap fragment, and no
 * fumble is charged (rules-group decision).
 */
export default class DeadBall extends Fragment {
    constructor(deadAt) {
        super();
        this.code = "DEAD";
        this.deadAt = deadAt;

        this.requiredData = [
            {
                name: "deadAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Dead Ball At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    getFieldPosition() {
        return this.deadAt;
    }

    summarize(summaryContext, stringifier) {
        const { gameConfig, homeTeam, awayTeam } = summaryContext;
        const message = `ball dead at ${stringifier.niceFieldPosition(
            gameConfig.general.fieldLength,
            this.deadAt,
            homeTeam?.abbrName,
            awayTeam?.abbrName
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        // The end context is built from these callbacks, not from
        // getFieldPosition(), and the end-zone checks that decide a safety
        // read it. Guard for 0 explicitly: the offense's own goal line is a
        // valid spot and a falsy one.
        if (this.deadAt || this.deadAt === 0) {
            summaryContext.fieldPosition = this.deadAt;
        }
        summaryContext.eopPrinted = true;
    }
}
